import { lazy, Suspense } from 'react';
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { muiTheme } from './muiTheme';

const MarketingApp = lazy(() => import('../marketing/MarketingApp'));
const App = lazy(async () => {
  const { installDemoFetchMock } = await import('../demo/mockApi');
  installDemoFetchMock();
  return import('../App');
});

export default function ThemedEntry({ marketing }: { marketing: boolean }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={muiTheme}>
        <CssBaseline />
        <Suspense fallback={null}>{marketing ? <MarketingApp /> : <App />}</Suspense>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
